import type { FieldTypeSpec } from './types';

const types = new Map<string, FieldTypeSpec>();

/** Make a field type available to every form; a later registration of the same type replaces it. */
export function registerFieldType(type: string, spec: FieldTypeSpec): void {
  types.set(type, spec);
}

export function fieldType(type: string): FieldTypeSpec {
  const spec = types.get(type);
  if (!spec) throw new Error(`Unknown field type "${type}" — register it with registerFieldType().`);
  return spec;
}
